// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"b0b0e6f6","727":"836e73b1"}[chunkId] + ".chunk.css";
};